export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/bundle.cd3c1a296f26c81bf0b6.min.worker.js");
}
